<template lang='pug'>
  div
    .login(v-if="login")
      p.name
        | ようこそ
        a(v-bind:href="buildUrl('mypage/')")
          span.clarity_mask {{ lastName }} {{ firstName }}さん
      p.point
        | 現在の所有ポイントは
        span {{ point }}pt
        | です
    .login(v-if="!login")
      p.name
        | カラコン全品送料無料
      p.point
        | 会員登録で更にお得！
</template>

<script>
import CustomerStore from '../../../stores/CustomerStore'
import config from '../../../components/config/Config'

export default {
  name: 'UserStatus',
  mixins: [config],
  computed: {
    /**
     * ポイント(フォーマットしている)
     * return ポイント
     */
    point () {
      return String(CustomerStore.state.user.point).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    /**
     * ログイン済みかどうか
     * @return ログイン済みかどうか
     */
    login () {
      return CustomerStore.state.user.login
    },
    /**
     * 名前を取得する
     * @return 名前
     */
    firstName () {
      return CustomerStore.state.user.firstName
    },
    /**
     * 名前を取得する
     * @return 名前
     */
    lastName () {
      return CustomerStore.state.user.lastName
    }
  },
  /**
   * mounted
   */
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.login{
  margin-left: 67px;
  width: 330px;
  float: left;
  padding-top: 29px;
  font-size: 12px;
  line-height: 1.4em;
  text-align: right;
  a{
    color: #000;
    font-style: normal;
    text-decoration: none;
  }
  .name{
    font-size: 13px;
  }
  .point{
    font-size: 13px;
    span{
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/common/UserStatus.vue